module.exports = __webpack_public_path__ + "static/img/vis_m.efc2453.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/relay-event/vis_m.jpg
// module id = uzxP
// module chunks = 0